"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _uiTheme = require("@kyruus/ui-theme");
const ButtonComponent = (0, _uiTheme.withMuiThemeAdapter)(_Button.default);
// This is silly, but it optimizes for developers.
// react-docgen can't find the propTypes unless it
// sees a component defininition.
const Button_ = props => /*#__PURE__*/_react.default.createElement(ButtonComponent, props);
Button_.displayName = 'Button';
// PropTypes taken from material-ui.
Button_.propTypes = {
  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * The default value is a `button`.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.default.string,
  /**
   * If `true`, and `variant` is `'fab'`, will use mini floating action button styling.
   */
  mini: _propTypes.default.bool,
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  /**
   * @ignore
   */
  type: _propTypes.default.string,
  /**
   * The type of button.
   */
  variant: _propTypes.default.oneOf(['flat', 'raised', 'fab'])
};
var _default = exports.default = Button_;
Button_.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "children": {
      "description": "The content of the button.",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "className": {
      "description": "@ignore",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "color": {
      "description": "The color of the component. It supports those theme colors that make sense for this component.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'default'",
          "computed": false
        }, {
          "value": "'inherit'",
          "computed": false
        }, {
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }]
      },
      "required": false
    },
    "component": {
      "description": "The component used for the root node.\nEither a string to use a DOM element or a component.\nThe default value is a `button`.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "func"
        }]
      },
      "required": false
    },
    "disabled": {
      "description": "If `true`, the button will be disabled.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disableFocusRipple": {
      "description": "If `true`, the  keyboard focus ripple will be disabled.\n`disableRipple` must also be true.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disableRipple": {
      "description": "If `true`, the ripple effect will be disabled.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "fullWidth": {
      "description": "If `true`, the button will take up the full width of its container.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "href": {
      "description": "The URL to link to when the button is clicked.\nIf defined, an `a` element will be used as the root node.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "mini": {
      "description": "If `true`, and `variant` is `'fab'`, will use mini floating action button styling.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "size": {
      "description": "The size of the button.\n`small` is equivalent to the dense button styling.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false
    },
    "type": {
      "description": "@ignore",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "variant": {
      "description": "The type of button.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'flat'",
          "computed": false
        }, {
          "value": "'raised'",
          "computed": false
        }, {
          "value": "'fab'",
          "computed": false
        }]
      },
      "required": false
    }
  }
};